<template>
    <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.2441 0V20.5" stroke="#242653"/>
        <path d="M20.5 10.2451L0 10.2451" stroke="#242653"/>
    </svg>
</template>